/**
 * R3 Phase 6 — workflow-number helpers.
 *
 * Mirrors the backend `workflow_number_service` and the existing
 * `runNumber.js` shape.  User-visible format is `"0001"` with **no**
 * `#` prefix and **no** `W` prefix — explicit user direction.
 *
 * Returns a single string so the Visual-Edits framework cannot split
 * tokens (same defensive pattern as `runRef`).
 */

export function formatWorkflowNumber(n) {
  if (n == null) return "—";
  const x = Number(n);
  if (!Number.isFinite(x) || x < 0) return "—";
  if (x < 10000) return String(x).padStart(4, "0");
  return String(x);
}

/** "0001" — canonical workflow reference token, NO prefix. */
export function workflowRef(n) {
  return formatWorkflowNumber(n);
}
